import RouteNames from '../../../../../../app/router/_internals/RouteNames.enum';

export default Object.freeze({
	GENERAL: `${RouteNames.USERS}-general`,
	COMMUNICATIONS: `${RouteNames.USERS}-communications`,
	VARIABLES: `${RouteNames.USERS}-variables`,
	TOKENS: `${RouteNames.USERS}-tokens`,
	LOGS: `${RouteNames.USERS}-logs`,
	PERMISSIONS: `${RouteNames.USERS}-permissions`,
});
